module.exports = __webpack_public_path__ + "img/google-pay.68b8a1dc.svg";